let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("76n7a"), load("l253H"), load("2ymnl")]).then(() => parcelRequire('knqHM'));